export default __webpack_public_path__ + "static/media/JobDesign-Register_2.d4beb09c.png";